export const getQuestionaire = (postmortemstate) => {
  const questions = postmortemstate?.questions || [];
  return questions
    .filter((que) => que && que.question)
    .map((que) => ({
      question: que.question,
      answer: que.answer || "",
    }));
};